module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 2-35bb6132325313822232e6b1db0b1bc8.jpg";